import React from 'react'

import { Container } from '@mui/material'
import { TitleComponentType } from '@src/Application/Types/ComponentTypes'

import { Heading, Wrapper } from './Title.styled'

export const Title = (props: TitleComponentType): JSX.Element => {
    const { title } = props

    return (
        <Wrapper>
            <Container>
                <Heading>{title}</Heading>
            </Container>
        </Wrapper>
    )
}
